import * as React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import { useAppDispatch, useAppSelector } from "./redux/hooks";
import { authenticate } from "./redux/reducers/user-slice";
import PasswordReset from "./pages/PasswordReset";
import { Loader2 } from "lucide-react";

const Room = React.lazy(() => import("./pages/Room"));
const Home = React.lazy(() => import("./pages/Home"));

export default () => {
  const loading = useAppSelector((state) => state.user.loading);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(authenticate());
  }, []);

  const loadingPage = () => {
    return (
      <div className="w-screen h-screen bg-[#111111] flex justify-center items-center">
        <Loader2 size={32} color="#d7d7d7" className="animate-spin" />
      </div>
    );
  };

  if (loading) {
    return loadingPage();
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <React.Suspense fallback={loadingPage()}>
              <Home />
            </React.Suspense>
          }
        />
        <Route
          path="/r/:inviteId"
          element={
            <React.Suspense fallback={loadingPage()}>
              <Room />
            </React.Suspense>
          }
        />
        <Route path="/sign-up" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<PasswordReset />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};
